import Contexts from './Contexts';
import { v4 } from 'uuid';
import { useReducer, useState, useEffect } from 'react';


/*
import { computeFilterArgs } from './SvgImageFilter';
import SvgImageFilter from './SvgImageFilter';
*/
import { computeFilterArgs } from './NewSvgImageFilter';
import SvgImageFilter from './NewSvgImageFilter';

import { FigureChannelAdjustmentContext } from './Contexts';

const DEFAULT = channels => channels.map((cc={}) => ({
    brightness:1,
    contrast:1,
    ...cc,
}))
 

function channelReducer(state, action) {
  const { type, _id, updates } = action;

  switch (type) {
    case "SET_STATE":{
      return action.state;
    }
    case "UPDATE_CHANNEL":
      return state.map(channel =>
        channel._id === _id
          ? { ...channel, ...updates }
          : channel
      );

    case "RESET_CHANNEL":
      return state.map(channel =>
        channel._id === _id
          ? Object.fromEntries(
              Object.entries(channel).filter(([key]) =>
                ["_id", "color"].includes(key)
              )
            )
          : channel
      );

    default:
      return state;
  }
}

export default function GlobalChannelSettingsProvider({
  defaultChannels, 
  defaultAdjustments, 
  defaultSelectedChannel, 
  onChange,
  children
}){


  //adjustments are things made, reset means it's all cleared... for a certain CHANNEL 
  //const [channels,channelAdjustmentsDispatch] = useReducer(channelReducer, defaultChannels ?? {})
  const [channels, setChannels] = useState(defaultChannels);

  // const adjustmentsByChannel = Object.fromEntries(channels.map(channel => ([channel._id,{
  //   ...DEFAULT,...channel
  // }])))
  
  const [adjustment, setAdjustment] = useState(defaultAdjustments ?? channels);

  //useEffect(() => { setAdjustment(defaultAdjustments); },[defaultAdjustments])



  /*let filterArgs = computeFilterArgs(adjustment);
  let filterId = v4();
  filterArgs.filterId = filterId;
 
  let filter = <SvgImageFilter {...{ filterArgs }}/>
  */
  let filter;


  return (

    <FigureChannelAdjustmentContext.Provider value={{
      channels,
      adjustment,
      defaultSelectedChannel,
      // channelAdjustmentsDispatch:action => {
      //   /*
      //    there's going to be some problems here if we're updating store...
      //    I guess we throttle / debounce it anyways so NBD.
      //   */
      //   let newState = channelAdjustmentsDispatch({
      //     type:"SET_STATE",
      //     state:channelReducer(channels,action)
      //   })
      //   onChange?.(newState);

      // },
      setAdjustment:val => { 
        onChange?.(val); setAdjustment(val) }, 
      //filterId,
    }}>
    {children}
    </FigureChannelAdjustmentContext.Provider>

  )


}
